var _path, _path2, _circle, _path3, _circle2, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _circle3, _path16, _path17, _path18;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChats = function SvgChats(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 121,
    height: 129,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#F5F5FA",
    strokeWidth: 4,
    d: "M119 56.5C119 26.402 94.6 2 64.5 2S10 26.402 10 56.5c0 30.1 24.4 54.501 54.5 54.501a54.248 54.248 0 0 0 26.204-6.705c3.767 2.681 12.958 8.027 22.037 4.176l-10.929-12.251A54.346 54.346 0 0 0 119 56.501Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#8083A3",
    d: "M19.582 56.5C19.582 28.026 41.306 4.655 69 2.216a54.586 54.586 0 0 0-4.791-.214C34.27 2 10 26.4 10 56.5S34.27 111 64.209 111c1.612 0 3.207-.077 4.783-.215-27.69-2.443-49.41-25.812-49.41-54.285Z",
    opacity: 0.1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 50.001,
    r: 5,
    fill: "#2F2E41"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBBEBE",
    d: "M23.656 64.638 21.111 62 16 63.693 16.49 70 27 69.48l-3.228-4.676-.116-.167Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 57.001,
    r: 8,
    fill: "#FBBEBE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F2E41",
    d: "M68.606 76s10.252 17.22 12.692 19.805A43.812 43.812 0 0 0 85 99.411s-1.147 3.719-2.974 3.586a8.745 8.745 0 0 1-3.013-.726s-.816-2.065-2.238-2.971c-1.422-.906-13.042-12.079-12.77-15.65.271-3.57 4.601-7.65 4.601-7.65Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F2E41",
    d: "M33 100.285s10.802 8.464 25.483.511l1.265-.94s-2.135 4.849-2.333 6.163c-.23 1.525-5.789 10.454-6.696 10.882-.907.428-1.107.822-1.107.822l3.85 4.278 1.423-1.058s5.55-7.938 7.173-9.39c1.623-1.452 9.357-16.427 9.357-16.427s2.957-5.643-4.423-6.067c-7.379-.424-10.775 1.606-10.775 1.606l-13.096 2.1L33 100.285ZM85.637 98 91 101.909s6.843 2.257 2.628 3.759c-4.215 1.502-15.323 2.045-15.575-.027-.251-2.073.439-5.334.993-5.156.554.178 4.4 1.23 6.59-2.483Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F2E41",
    d: "m54.926 119.596.983 5.398s2.794 5.346-.56 3.687c-3.356-1.658-10.268-7.959-9.247-9.279 1.02-1.321 3.273-2.754 3.502-2.323.229.43 1.922 3.312 5.322 2.517Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45 94.236s-7.212 8.508-11.59 6.441c-4.38-2.067-22.293-26.004-20.248-30.428 2.045-4.424 2.731-3.482 2.731-3.482l9.25.864-2.662-4.311s1.243-.924 2.427.373c1.184 1.297 5.938 4.536 7.594 9.11 1.656 4.576 6.518 4.347 6.518 4.347L45 94.236Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "M74 76.582 61.34 90.001 50 70.007l10.781-13.006L74 76.582Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M74 77.255 62.459 89 52 70.9 61.591 59 74 77.255Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#B3B3B3",
    d: "m61.389 90 .611.549-.392.83L44.165 97 44 96.353l.794-.888L61.389 90Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#D0CDE1",
    d: "m62 90.188-18.638 5.813L32 74.588l18.31-4.587L62 90.188Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "m61 87.406-.827.595L51 72.433l.948-.432L61 87.406Zm-2 .329-7.962 2.266L42 74.73 49.877 73 59 87.735Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBBEBE",
    d: "m37.013 76.667 1.65-.48s9.201-1.068 9.336 1.902c.134 2.97-10.572 1.592-10.572 1.592L36 77.69l1.013-1.022ZM44.916 90l2.141-.983s6.463-3.246 4.609-5.36c-1.854-2.115-7.571 1.557-7.571 1.557L43 86.377 44.916 90Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M43.043 85.468s3.668 3.594 2.834 4.438c-.835.845-14.522 11.949-17.915 8.396-3.392-3.553-19.922-21.391-13.49-22.92 6.432-1.53 8.131 2.046 8.131 2.046l8.491 14.282 11.95-6.242ZM32.413 74 38 75.919l-.091 4.083L32 79.355l.413-5.354Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M37 87.337 30.466 91 23 80l7.206 9.06L37 87.337Z",
    opacity: 0.2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 54.001,
    r: 10,
    fill: "#2F2E41"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#6E35C1",
    d: "M66.835 78 60 67.698 62.898 64 70 74.6 66.835 78Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M66.53 82 56 66.63l.52-.63L67 81.408l-.47.594Zm-1 1L55 67.63l.52-.63L66 82.408l-.47.594Zm-1 2L54 69.63l.52-.63L65 84.408l-.47.594Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F2E41",
    d: "M19 48h3.094C25.356 48 28 50.688 28 54h-9v-6Z"
  })));
};
export default SvgChats;